export default __webpack_public_path__ + "static/media/usda-logo--white.b84ab820.svg";